import ProfileLayout from './ProfileLayout/ProfileLayout'
import GeneratorLayout from './GeneratorLayout/GeneratorLayout'

export { ProfileLayout, GeneratorLayout }
